import * as React from 'react';
import { Row, Col } from 'antd';
import AdministratorDetailForm from '../../Components/Content/Administrators/AdministratorDetailForm';

export interface Props {
    children?: React.ReactNode;
}

const AdminDetailFormPage: React.FC<Props> = ({ children }) => {
    return (
        <AdministratorDetailForm />
    );
};

export default AdminDetailFormPage;
